// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import companiesReducer from './slices/companiesSlice';
import allotCustomerSlice from "./slices/allotCustomerStore";
import transferInSlice from "./slices/transferIn";
import transferOutSlice from "./slices/transferOut";
import bulkTransfersSlice from "./slices/bulkTransfersSlice";
import orderItemsReducer from './slices/orderItemsSlice';


// src/redux/store.js
export const store = configureStore({
  reducer: {
    allotStore: allotCustomerSlice,
    transferInStore: transferInSlice,
    transferOutStore: transferOutSlice,
    companies: companiesReducer, // Changed from 'Companies' to 'companies'
    bulkTransfers: bulkTransfersSlice,
    orderItems: orderItemsReducer,

  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});
